import * as React from "react";
import { singleton } from "logic/singleton";
const EventDetailsContext = React.createContext({
  hideEventDefinitionEdit: false,
  hideNotesEdit: false
});
export default singleton("contexts.EventDetailsContext", () => EventDetailsContext);
